import { StoreService } from "../../lib/qc-api-client";
import {
  createUserError,
  createUserPending,
  createUserSuccess,
} from "../actions/user";
import {
  getProductsError,
  getProductsPending,
  getProductsSuccess,
} from "../actions/store";

export const processTransaction = (user, company, order, job, token) => {
  return (dispatch) => {
    dispatch(createUserPending());
    StoreService.processTransaction(user, company, order, job, token)
      .then((response) => {
        dispatch(createUserSuccess(response.data));
      })
      .catch((error) => dispatch(createUserError(error)));
  };
};

export const getStoreProducts = () => {
  return (dispatch) => {
    dispatch(getProductsPending());
    StoreService.getProducts()
      .then((response) => {
        dispatch(getProductsSuccess(response.data.products));
      })
      .catch((error) => dispatch(getProductsError(error)));
  };
};
